import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
// import { MatConfirmDialogComponent } from './mat-confirm-dialog/mat-confirm-dialog.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'prefix' },
    { path: '', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule), canActivate: [AuthGuard] },
    { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
    { path: 'Home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
    { path: 'Signup', loadChildren: () => import('./signup/signup.module').then(m => m.SignupModule) },
    { path: 'error', loadChildren: () => import('./server-error/server-error.module').then(m => m.ServerErrorModule) },
    { path: 'access-denied', loadChildren: () => import('./access-denied/access-denied.module').then(m => m.AccessDeniedModule) },
    { path: 'not-found', loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundModule) },
    { path: 'change-password', loadChildren: () => import('./change-password/change-password.module').then(m => m.ChangePasswordModule) },
    { path: 'expire-change-password', loadChildren: () => import('./expire-change-password/expire-change-password.module').then(m => m.ExpireChangePasswordModule) },
    { path: 'CalSchoolReport/:id/:id1', loadChildren: () => import('./calschoolreport/calschoolreport.module').then(m => m.CalschoolreportModule) },
    { path: 'CalCenterReport/:id/:id1', loadChildren: () => import('./calcenterreport/calcenterreport.module').then(m => m.CalcenterreportModule) },
    { path: '**', redirectTo: 'not-found' }

];


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],


})
export class AppRoutingModule { }
